function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.429 1.21A6 6 0 0111.875 3.5V2.312a.562.562 0 111.125 0V5.5H9.812a.562.562 0 110-1.125h1.296a4.875 4.875 0 10.394 4.495.562.562 0 111.039.432A6 6 0 115.429 1.21z",
  fill: "currentColor"
});

var SvgRepeat = function SvgRepeat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref);
};

export default SvgRepeat;